// extracted by mini-css-extract-plugin
module.exports = {"object3D":"Model3D_object3D__WQhSX"};